import useDocumentTitle from '../../../../a11y/hooks/useDocumentTitle';

/**
 * Sets the document title for accessibility on report pages.
 * Renders children passthrough.
 */
export default function ReportAnalytics(props) {
  const { title, children } = props;

  useDocumentTitle(title);

  if (children) {
    return children;
  }
  return null;
}
